import { useDispatch } from 'react-redux'
import { setDisabledRelations, setDisabledTypes } from 'Actions/explore'
import { RELATION, TYPE } from 'Types'
import { connect } from 'react-redux'
import './index.scss'

const FilterBody = ({
  idField,
  filterValue,
  items,
  updateFilter,
  CellRenderItem,
  configNode,
  disabledTypes,
  disabledRelations,
  setDisabledRelations,
  setDisabledTypes
}) => {
  const dispatch = useDispatch()

  const onCheck = ({ target: { value, checked }}) => {
    dispatch(updateFilter({ [idField]: value, enabled: checked }));
  };

  const getRelevantStoreItems = (shouldEnable, item) => {
    const identifier = item.key || item.id;

    let filterType, data, updateStoreFn;

    if (item.id != null) {
      filterType = TYPE;
      data = disabledTypes;
      updateStoreFn = setDisabledTypes;
    } else if (item.key != null) {
      filterType = RELATION;
      data = disabledRelations;
      updateStoreFn = setDisabledRelations;
    }

    if (shouldEnable) {
      data = data.filter((elem) => elem !== identifier);
    } else {
      data = [...data, identifier];
    }

    return { updateStoreFn, data };
  };

  const updateDefaultEnabledItem = (shouldEnable, filterItem) => {
    const { updateStoreFn, data } = getRelevantStoreItems(shouldEnable, filterItem);
    const cleanData = _.uniq(data);
    updateStoreFn(cleanData);

    configNode.update(cleanData);
  };

  const filter = (items) => {
    return _.filter(items, ({ label }) => {
      return label?.toLowerCase().includes(filterValue.toLowerCase());
    });
  };

  return (
    <div style={{ whiteSpace: 'nowrap', overflow: 'auto', flex: '1 1 auto' }}>
      {
        filter(items).map((item, i) => (
          <CellRenderItem
            item={item}
            onChange={onCheck}
            onClick={(bool) => updateDefaultEnabledItem(bool, item)}
            key={item.id ? `${item.id}-${i}` : `${item.key}-${i}`}
          />
        ))
      }
    </div>
  )
}

const mapStateToProps = ({ explore: { disabledRelations, disabledTypes }}) => ({
  disabledRelations,
  disabledTypes
});

const mapDispatchToProps = {
  setDisabledRelations,
  setDisabledTypes
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBody);
